/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Email_InvalidInputs */



/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Newsletter_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const newsletter_email_invalid = /** @type {((inputs?: Newsletter_Email_InvalidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Email_InvalidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("请输入有效的电子邮箱地址")
	return /** @type {LocalizedString} */ ("Please enter a valid email address")
});